export default __webpack_public_path__ + "static/media/last-updated-icon.0650e56b.svg";